import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77d10f0d")

_pushScopeId("data-v-77d10f0d")
const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-stretch overflow-hidden" }
const _hoisted_5 = { class: "col-11 col-md-11 col-lg-7 flex align-items-stretch" }
const _hoisted_6 = { class: "col-11 col-md-11 col-lg-5 flex align-items-stretch" }
const _hoisted_7 = { class: "section" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row align-items-stretch" }
const _hoisted_10 = { class: "col-12 col-lg-6 mb-4 mb-lg-0 flex align-items-stretch" }
const _hoisted_11 = { class: "col-12 col-lg-6 flex align-items-stretch" }
const _hoisted_12 = { class: "section" }
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "row overflow-hidden" }
const _hoisted_15 = { class: "col-11 col-md-6 flex align-items-stretch" }
const _hoisted_16 = { class: "col-11 col-md-6 flex align-items-stretch" }
const _hoisted_17 = { class: "section" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "row overflow-hidden" }
const _hoisted_20 = { class: "col-11 col-md-6 flex align-items-stretch" }
const _hoisted_21 = { class: "col-11 col-md-6 flex align-items-stretch" }
const _hoisted_22 = { class: "section" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "section about-system" }
const _hoisted_27 = { class: "container" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "about-system__text" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "section news" }
const _hoisted_33 = { class: "container" }
const _hoisted_34 = { class: "section faq" }
const _hoisted_35 = { class: "container" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HomeBanner = _resolveComponent("HomeBanner")
  const _component_Top10Country = _resolveComponent("Top10Country")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_StatGender = _resolveComponent("StatGender")
  const _component_StatAge = _resolveComponent("StatAge")
  const _component_StatPlacement = _resolveComponent("StatPlacement")
  const _component_DigestLine = _resolveComponent("DigestLine")
  const _component_DigestCircle = _resolveComponent("DigestCircle")
  const _component_CreateReport = _resolveComponent("CreateReport")
  const _component_HomeAbout = _resolveComponent("HomeAbout")
  const _component_HomeNews = _resolveComponent("HomeNews")
  const _component_FaqBlock = _resolveComponent("FaqBlock")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_HomeBanner)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Top10Country)
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.home.title1'),
          href: '/touch-bord',
          class: "section__title"
        }, null, 8, ["title"]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_StatGender)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_StatAge)
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.home.title2'),
          href: '/statistics-three',
          class: "section__title"
        }, null, 8, ["title"]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_StatPlacement, { year: 2022 })
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_StatPlacement, { year: 2023 })
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.home.title3'),
          href: '/digest',
          class: "section__title"
        }, null, 8, ["title"]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_DigestLine)
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_DigestCircle)
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_22, [
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.home.title4'),
          href: '/create-report',
          class: "section__title"
        }, null, 8, ["title"]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode(_component_CreateReport)
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_26, [
      _createVNode("div", _hoisted_27, [
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.home.title5'),
          href: '/about-system',
          class: "section__title about-system__title"
        }, null, 8, ["title"]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('pages.home.aboutSystem')), 1)
          ]),
          _createVNode("div", _hoisted_31, [
            _createVNode(_component_HomeAbout)
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_32, [
      _createVNode("div", _hoisted_33, [
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.home.title6'),
          href: '/news',
          class: "section__title news__title"
        }, null, 8, ["title"])
      ]),
      _createVNode(_component_HomeNews)
    ]),
    _createVNode("section", _hoisted_34, [
      _createVNode("div", _hoisted_35, [
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.home.title7'),
          class: "section__title faq__title"
        }, null, 8, ["title"]),
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            _createVNode(_component_FaqBlock)
          ])
        ])
      ])
    ])
  ]))
})